var arr = [
  {
    title: 'الصفحة الرئيسية',
    route: 'home',
    icon: 'HomeIcon'
  },
  {
    title: 'المستخدمين',
    route: 'users',
    icon: 'UsersIcon'
  },
  {
    title: 'الاجهزة',
    route: 'devices',
    icon: 'ServerIcon'
  },
  {
    title: 'الطلبات',
    route: 'orders',
    icon: 'ShoppingBagIcon'
  },
  {
    title: 'تسجيل الخروج',
    route: 'logout',
    icon: 'LogOutIcon'
  },
], arr2 = [], user = JSON.parse(localStorage.getItem("user"));

arr.forEach(function (e) {
  if(user?.pers){
    if(!e.per){
      arr2.push(e)
    }else{
      if(user.pers.includes("*") || user.pers.includes(e.per) || !e.per){
        arr2.push(e)
      }
    }
  }else{
    arr2.push(e)
  }
})

export default arr2
